import React, { useState } from "react";
import "./index.css";

import ImageModal from "../cropper/ImageModal";
import constants from "../../../constants";
import messages from "../../../constants/messages";

/* eslint-disable jsx-a11y/anchor-is-valid */

const ImageInput = ({
  name,
  onChange,
  showPreview,
  imageData,
  defaultPic,
  onError,
}) => {
  const [image, setImage] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const onChangeHandler = file => {
    onChange({
      [name]: {
        data: file[0],
        src: URL.createObjectURL(file[0]),
      },
    });
  };

  const handleFile = e => {
    if (e.target.files.length > 0) {
      const file = e.target.files;
      const maxAllowedSize = 5 * 1024 * 1024;
      if (file[0].size > maxAllowedSize) {
        onError(messages.MAX_FILE_SIZE);
      } else {
        if (
          constants.DOCUMENT_IMAGE_SUPPORTED_TYPES.includes(
            file[0].name.split(".").pop().toLowerCase()
          )
        ) {
          setImage(file[0]);
          setModalIsOpen(true);
        } else {
          onError(messages.INVALID_FILE);
        }
      }
      e.target.value = null;
    }
  };

  let inputElement;

  const icon = (
    <svg
      fill={"white"}
      width="13px"
      height="13px"
      viewBox="0 0 16 16"
      className="bi bi-pencil-fill"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
      />
    </svg>
  );

  return (
    <>
      <ImageModal
        modalIsOpen={modalIsOpen}
        closeModal={() => {
          setModalIsOpen(prevState => !prevState);
        }}
        image={image}
        onCropImage={croppedImg => onChangeHandler([croppedImg])}
        imageAspect={1}
      />
      {showPreview && (
        <div className="img-container mb-5 position-relative mx-auto">
          <img
            key={imageData?.src}
            src={imageData && imageData.src ? imageData.src : defaultPic}
            className={(!imageData || !imageData["src"]) && "defualt-image"}
            style={{
              objectFit: "contain",
              objectPosition: "50% 50%",
              marginTop: imageData && imageData.src ? undefined : 15,
              height: 135,
              width: 135,
              padding: imageData && imageData.src ? undefined : 15,
              borderRadius: "50%",
              border:
                imageData && imageData.src
                  ? "2px solid var(--outline-color)"
                  : "2px solid",
            }}
            alt="img"
            onError={e => (e.target.src = defaultPic)}
          />
          <div className="edit-button">
            <a onClick={() => inputElement.click()}>{icon}</a>
          </div>
        </div>
      )}
      <input
        ref={input => (inputElement = input)}
        accept="image/*"
        type="file"
        style={{ display: "none" }}
        onChange={handleFile}
      />
    </>
  );
};

export default ImageInput;
